export default {
  resource_center_title: 'Resource Center',
  resource_center_empty: 'No help resources are available.',
  resource_center_new_tab: '(opens in a new tab)',
  configure_resource_center_description_part1:
    'Manage the help links shown in the Resource Center. Users see a link if they hold',
  configure_resource_center_description_emphasis: 'any',
  configure_resource_center_description_part2:
    'of its permissions. Reorder by dragging, or focus a drag handle and press Space to pick it up, then use the arrow keys.',
  configure_resource_center_add_link: '+ Add link',
  configure_resource_center_form_title_add: 'Add Link',
  configure_resource_center_form_title_edit: 'Edit Link',
  configure_resource_center_url_label: 'URL',
  configure_resource_center_url_required: 'URL is required',
  configure_resource_center_url_invalid: 'URL must be a valid URL',
  configure_resource_center_label: '{{language}} Label',
  configure_resource_center_label_required: 'Label is required',
  configure_resource_center_subheading_label:
    '{{language}} Subheading Label (Optional)',
  configure_resource_center_products_title:
    'Products: (user needs any one to see the link)',
  configure_resource_center_products_label: 'Products',
  configure_resource_center_cancel: 'Cancel',
  configure_resource_center_save_changes: 'Save changes',
  configure_resource_center_toast_changes_saved: 'Changes saved successfully',
  configure_resource_center_toast_link_added: 'Link added successfully',
  configure_resource_center_edit: 'Edit',
  configure_resource_center_delete: 'Delete',
  configure_resource_center_undo_message: '"{{label}}" was deleted',
  configure_resource_center_undo: 'Undo',
  configure_resource_center_undo_error:
    'Could not restore the link. Please try again.',
  configure_resource_center_delete_error:
    'Could not delete the link. Please try again.'
};
